<template>
  <ContainerScrolling class="LatestListing">
    <LayoutFill :no-gutters="solidHeader" :no-padding="solidHeader">
      <MainBanner
        title="Latest Content"
        :rss-feed="true"
        :solid-header="solidHeader"
      />
    </LayoutFill>
    <LayoutGutters>
      <SelectedArticles
        :title="articlesDateRange"
        :articles="latestItems"
        :show-content-type="showContentTypeLatest"
        :show-large-title="false"
        :show-metrics="false"
        :show-published="true"
      />
    </LayoutGutters>
  </ContainerScrolling>
</template>

<script>
import { mapState } from "vuex";
import mapFlags from "~/plugins/utilities/mapFlags";

import buildActionDispatcher from "~/actions/utilities/buildActionDispatcher";

import {
  displayIsMobile,
  displayIsTablet,
  displayIsDesktop,
} from "~/components/utilities/displayBreakpoints";

import ContainerScrolling from "~/components/layout/ContainerScrolling.vue";
import LayoutGutters from "~/components/layout/LayoutGutters";
import LayoutFill from "~/components/layout/LayoutFill";

import MainBanner from "~/components/banner/MainBanner.vue";
import SelectedArticles from "~/components/articles/SelectedArticles.vue";

import toCanonicalUrl from "~/plugins/utilities/toCanonicalUrl.js";
import getPageTitle from "~/plugins/utilities/getPageTitle.js";
import getSiteName from "~/plugins/utilities/getSiteName.js";

export default {
  name: "LatestListing",
  components: {
    ContainerScrolling,
    MainBanner,
    LayoutGutters,
    LayoutFill,
    SelectedArticles,
  },
  async fetch(context) {
    if (Object.keys(context.query).length !== 0) {
      context.redirect({
        path: `/engage/${context.$config.partner}/public-dashboard`,
      });
    } else {
      await buildActionDispatcher("loadLatestContent")(context);
    }
  },
  head() {
    const { siteName, domain, partner } = this;

    const pageTitle = `Latest Content | ${getPageTitle(siteName)}`;
    const cupTechText = this.partner === "brought to you by";

    const pageAddress = "latest-listing";
    const canonicalUrl = toCanonicalUrl(pageAddress, partner);

    return {
      title: pageTitle,

      meta: [
        {
          hid: "description",
          name: "description",
          content: `Read the latest content in ${domain} from ${siteName}, ${cupTechText} Cambridge University Press.`,
        },
      ],
      link: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  computed: {
    ...mapState({
      layout: (state) => state.theme.layout,
      latestItems: (state) => state.currentOrigin.latestItems,
      domain: (state) => state.theme.domain,
      siteName: (state) => getSiteName(state.theme),
      lastItemRange: (state) => state.theme.lastItemsRange,
    }),
    ...mapFlags(["showContentTypeLatest"]),
    articlesDateRange() {
      switch (this.lastItemRange) {
        case "LAST_3_MONTHS":
          return "Last Three Months";
        case "LAST_MONTH":
          return "Last Month";
        case "LAST_WEEK":
          return "Last Week";
        default:
          return "Last Three Months";
      }
    },
    partner() {
      return this.$config.partner;
    },
    displayIsMobile,
    displayIsTablet,
    displayIsDesktop,
    solidHeader() {
      return this.layout.mainBannerSolidHeader;
    },
  },
  watchQuery: ["category", "publishedDates"],
};
</script>
